import { z } from 'zod';

export const ProviderEnvOverridesSchema = z.object({
  ABLIT_API_BASE_URL: z.string().optional(),
  ABLIT_KEY: z.string().optional(),
  AI21_API_BASE_URL: z.string().optional(),
  AI21_API_KEY: z.string().optional(),
  AIML_API_KEY: z.string().optional(),
  ANTHROPIC_API_KEY: z.string().optional(),
  ANTHROPIC_BASE_URL: z.string().optional(),
  ANTHROPIC_CUSTOM_HEADERS: z.string().optional(),
  ANTHROPIC_TEMPERATURE: z.string().optional(),
  ATLASCLOUD_API_KEY: z.string().optional(),
  AWS_ACCESS_KEY_ID: z.string().optional(),
  AWS_BEARER_TOKEN_BEDROCK: z.string().optional(),
  AWS_BEDROCK_REGION: z.string().optional(),
  AWS_PROFILE: z.string().optional(),
  AWS_SECRET_ACCESS_KEY: z.string().optional(),
  AWS_SESSION_TOKEN: z.string().optional(),
  AZURE_API_BASE_URL: z.string().optional(),
  AZURE_AI_PROJECT_URL: z.string().optional(),
  AZURE_API_HOST: z.string().optional(),
  AZURE_API_KEY: z.string().optional(),
  AZURE_AUTHORITY_HOST: z.string().optional(),
  AZURE_CLIENT_ID: z.string().optional(),
  AZURE_CLIENT_SECRET: z.string().optional(),
  AZURE_DEPLOYMENT_NAME: z.string().optional(),
  AZURE_EMBEDDING_DEPLOYMENT_NAME: z.string().optional(),
  AZURE_OPENAI_API_BASE_URL: z.string().optional(),
  AZURE_OPENAI_API_HOST: z.string().optional(),
  AZURE_OPENAI_API_KEY: z.string().optional(),
  AZURE_OPENAI_BASE_URL: z.string().optional(),
  AZURE_OPENAI_DEPLOYMENT_NAME: z.string().optional(),
  AZURE_OPENAI_EMBEDDING_DEPLOYMENT_NAME: z.string().optional(),
  AZURE_TENANT_ID: z.string().optional(),
  AZURE_TOKEN_SCOPE: z.string().optional(),
  CDP_DOMAIN: z.string().optional(),
  CDP_TOKEN: z.string().optional(),
  CLAUDE_CODE_USE_BEDROCK: z.string().optional(),
  CLAUDE_CODE_USE_VERTEX: z.string().optional(),
  CLAUDE_CONFIG_DIR: z.string().optional(),
  CLOUDFLARE_ACCOUNT_ID: z.string().optional(),
  CLOUDFLARE_API_KEY: z.string().optional(),
  CLOUDFLARE_GATEWAY_ID: z.string().optional(),
  CF_AIG_TOKEN: z.string().optional(),
  CEREBRAS_API_KEY: z.string().optional(),
  COMETAPI_KEY: z.string().optional(),
  COHERE_API_BASE_URL: z.string().optional(),
  COHERE_API_KEY: z.string().optional(),
  COHERE_CLIENT_NAME: z.string().optional(),
  DATABRICKS_TOKEN: z.string().optional(),
  DATABRICKS_WORKSPACE_URL: z.string().optional(),
  DASHSCOPE_API_KEY: z.string().optional(),
  DEEPSEEK_API_KEY: z.string().optional(),
  DOCKER_MODEL_RUNNER_BASE_URL: z.string().optional(),
  DOCKER_MODEL_RUNNER_API_KEY: z.string().optional(),
  ELEVENLABS_API_KEY: z.string().optional(),
  ENVOY_API_BASE_URL: z.string().optional(),
  ENVOY_API_KEY: z.string().optional(),
  F5_API_BASE_URL: z.string().optional(),
  F5_API_KEY: z.string().optional(),
  FAL_KEY: z.string().optional(),
  FIREWORKS_API_BASE_URL: z.string().optional(),
  FIREWORKS_API_KEY: z.string().optional(),
  GITHUB_TOKEN: z.string().optional(),
  GOOGLE_API_HOST: z.string().optional(),
  GOOGLE_APPLICATION_CREDENTIALS: z.string().optional(),
  GOOGLE_API_BASE_URL: z.string().optional(),
  GOOGLE_API_KEY: z.string().optional(),
  GOOGLE_CLOUD_PROJECT: z.string().optional(),
  GOOGLE_CLOUD_LOCATION: z.string().optional(),
  GOOGLE_PROJECT_ID: z.string().optional(),
  GOOGLE_LOCATION: z.string().optional(),
  GOOGLE_GENERATIVE_AI_API_KEY: z.string().optional(),
  GOOGLE_GENAI_USE_VERTEXAI: z.string().optional(),
  GEMINI_API_KEY: z.string().optional(),
  GROQ_API_KEY: z.string().optional(),
  HELICONE_API_KEY: z.string().optional(),
  HF_API_TOKEN: z.string().optional(),
  HF_TOKEN: z.string().optional(),
  HYPERBOLIC_API_KEY: z.string().optional(),
  HUGGING_FACE_HUB_TOKEN: z.string().optional(),
  JFROG_API_KEY: z.string().optional(),
  LANGFUSE_BASE_URL: z.string().optional(),
  LANGFUSE_HOST: z.string().optional(),
  LANGFUSE_PUBLIC_KEY: z.string().optional(),
  LANGFUSE_SECRET_KEY: z.string().optional(),
  LITELLM_API_BASE: z.string().optional(),
  LITELLM_API_KEY: z.string().optional(),
  LLAMA_BASE_URL: z.string().optional(),
  LLAMA_API_KEY: z.string().optional(),
  LOCALAI_BASE_URL: z.string().optional(),
  LOCALAI_TEMPERATURE: z.string().optional(),
  MISTRAL_API_BASE_URL: z.string().optional(),
  MISTRAL_API_HOST: z.string().optional(),
  MISTRAL_API_KEY: z.string().optional(),
  MINIMAX_API_KEY: z.string().optional(),
  MOONSHOT_API_KEY: z.string().optional(),
  MLFLOW_GATEWAY_API_KEY: z.string().optional(),
  MLFLOW_GATEWAY_URL: z.string().optional(),
  MODEL_API_KEY: z.string().optional(),
  MODELSLAB_API_KEY: z.string().optional(),
  N8N_API_KEY: z.string().optional(),
  NSCALE_SERVICE_TOKEN: z.string().optional(),
  NSCALE_API_KEY: z.string().optional(),
  NOVITA_API_KEY: z.string().optional(),
  NVIDIA_API_BASE_URL: z.string().optional(),
  NVIDIA_API_KEY: z.string().optional(),
  OLLAMA_API_KEY: z.string().optional(),
  OLLAMA_BASE_URL: z.string().optional(),
  OPENAI_API_BASE_URL: z.string().optional(),
  OPENAI_API_HOST: z.string().optional(),
  OPENAI_API_KEY: z.string().optional(),
  OPENAI_BASE_URL: z.string().optional(),
  OPENAI_ORGANIZATION: z.string().optional(),
  CLAWDBOT_GATEWAY_PASSWORD: z.string().optional(),
  CLAWDBOT_GATEWAY_TOKEN: z.string().optional(),
  CLAWDBOT_GATEWAY_URL: z.string().optional(),
  CODEX_API_KEY: z.string().optional(),
  OPENCLAW_CONFIG_PATH: z.string().optional(),
  OPENCLAW_GATEWAY_PASSWORD: z.string().optional(),
  OPENCLAW_GATEWAY_PORT: z.string().optional(),
  OPENCLAW_GATEWAY_TOKEN: z.string().optional(),
  OPENCLAW_GATEWAY_URL: z.string().optional(),
  ORCAROUTER_API_KEY: z.string().optional(),
  PALM_API_HOST: z.string().optional(),
  PALM_API_KEY: z.string().optional(),
  PERPLEXITY_API_KEY: z.string().optional(),
  PORTKEY_API_BASE_URL: z.string().optional(),
  PORTKEY_API_KEY: z.string().optional(),
  PROMPTFOO_CA_CERT_PATH: z.string().optional(),
  PROMPTFOO_DISABLE_TEMPLATE_ENV_VARS: z.string().optional(),
  PROMPTFOO_DISABLE_TEMPLATING: z.string().optional(),
  PROMPTFOO_MAX_CONCURRENCY: z.string().optional(),
  PROMPTFOO_PFX_CERT_PATH: z.string().optional(),
  PROMPTFOO_TRACING_ENABLED: z.string().optional(),
  PROMPTFOO_PFX_PASSWORD: z.string().optional(),
  PROMPTFOO_JKS_CERT_PATH: z.string().optional(),
  PROMPTFOO_JKS_PASSWORD: z.string().optional(),
  PROMPTFOO_JKS_ALIAS: z.string().optional(),
  PROMPTFOO_INSECURE_SSL: z.string().optional(),
  PROMPTFOO_PYTHON: z.string().optional(),
  PROMPTFOO_PYTHON_WORKERS: z.string().optional(),
  QUIVERAI_API_KEY: z.string().optional(),
  QWAK_TOKEN: z.string().optional(),
  REPLICATE_API_KEY: z.string().optional(),
  REPLICATE_API_TOKEN: z.string().optional(),
  SHAREPOINT_BASE_URL: z.string().optional(),
  SHAREPOINT_CERT_PATH: z.string().optional(),
  SHAREPOINT_CLIENT_ID: z.string().optional(),
  SHAREPOINT_TENANT_ID: z.string().optional(),
  SLACK_BOT_TOKEN: z.string().optional(),
  SNOWFLAKE_ACCOUNT_IDENTIFIER: z.string().optional(),
  TOGETHER_API_KEY: z.string().optional(),
  TRUEFOUNDRY_API_KEY: z.string().optional(),
  TYPESAFE_API_KEY: z.string().optional(),
  VERCEL_AI_GATEWAY_API_KEY: z.string().optional(),
  VERCEL_AI_GATEWAY_BASE_URL: z.string().optional(),
  VERTEX_API_HOST: z.string().optional(),
  VERTEX_API_KEY: z.string().optional(),
  VERTEX_API_VERSION: z.string().optional(),
  VERTEX_PROJECT_ID: z.string().optional(),
  VERTEX_PUBLISHER: z.string().optional(),
  VERTEX_REGION: z.string().optional(),
  VOYAGE_API_BASE_URL: z.string().optional(),
  VOYAGE_API_KEY: z.string().optional(),
  WATSONX_AI_APIKEY: z.string().optional(),
  WATSONX_AI_AUTH_TYPE: z.string().optional(),
  WATSONX_AI_BEARER_TOKEN: z.string().optional(),
  WATSONX_AI_PROJECT_ID: z.string().optional(),
  XAI_API_BASE_URL: z.string().optional(),
  XAI_API_KEY: z.string().optional(),
  AZURE_CONTENT_SAFETY_ENDPOINT: z.string().optional(),
  AZURE_CONTENT_SAFETY_API_KEY: z.string().optional(),
  AZURE_CONTENT_SAFETY_API_VERSION: z.string().optional(),
  AWS_REGION: z.string().optional(),
  AWS_DEFAULT_REGION: z.string().optional(),
  AWS_SAGEMAKER_MAX_TOKENS: z.string().optional(),
  AWS_SAGEMAKER_TEMPERATURE: z.string().optional(),
  AWS_SAGEMAKER_TOP_P: z.string().optional(),
  AWS_SAGEMAKER_MAX_RETRIES: z.string().optional(),
  PROMPTFOO_EVAL_TIMEOUT_MS: z.string().optional(),
});

// The runtime schema silently strips unknown keys at parse time (zod's default
// `z.object` mode). The type widens with `Record<string, string | undefined>`
// so downstream code can read arbitrary template variables (e.g.,
// `{{ env.MY_CUSTOM_VAR }}`) without a cast; callers that need to preserve
// unknown keys must read them off the unparsed source object.
export type EnvOverrides = z.infer<typeof ProviderEnvOverridesSchema> &
  Record<string, string | undefined>;
